import baseTheme from './baseTheme';
import { StyledComponentsThemeProps } from './StyledComponentsThemeProps';

export const styledComponentsTheme: StyledComponentsThemeProps = {
  ...baseTheme,
  dimensions: {
    container: {
      maxWidth: '1200px'
    }
  }
};
